
import * as EnumDatepicker from '@tunnel-enums/styled/index';
import styled, {css} from 'styled-components';

{ /** Utilisation des props modifier */
}
/**
 * @description : modification des props
 * @const
 * @name  Hours
 */
export const Hours = styled.div`
    margin-top: ${(props: SmallProps) => (props.isSmall ? '10px' : '10px')};
    width: 100%;
    border-top: 1px solid ${EnumDatepicker.CSS.BORDERCOLOR};
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: center;
  `;
/**
 * @description : modification des props
 * @const
 * @name  HoursContainer
 */
export const HoursContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: center;
  `;
/**
 * @description : modification des props
 * @const
 * @name  HoursContainer
 */
export const Form = styled.form`
    margin-bottom: 10px;
    margin-top: 10px;
    display: flex;
    align-content: center;
    align-items: center;
  `;
/**
 * @description : modification des props
 * @const
 * @name  Empty
 */
export const Empty = styled.div`
    width: 0;
    height: 0;
  `;

/**
 * @description : modification des props
 * @const
 * @name  Label
 */
export const Label = styled.label<LabelProps>`
    padding: 0px;
    padding-left: 5px;
    padding-right: 5px;
    color: ${EnumDatepicker.CSS.DARKGREY};
    font-size: ${(props: LabelProps) => (props.isSmall ? '13px' : '14px')};
    width: ${props => props.width};
    letter-spacing: 1px;
    font-weight: 400;
  `;
/**
 * @description : modification des props
 * @const
 * @name  TimeInput
 */
export const TimeInput = styled.input<SmallProps>`
    border: ${
    props => props.error ? '1px solid #ed5b56' :
                           `1px solid ${EnumDatepicker.CSS.COLOR}`};
    
    border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
    overflow: hidden !important;
    padding: 0;
    text-align:center;
    font-size: ${(props: SmallProps) => (props.isSmall ? '13px' : '12px')};
    padding-left: 5px;
    width:50px;
    padding-right: 5px;
    height: ${(props: SmallProps) => (props.isSmall ? '28px' : '28px')};
    background: ${EnumDatepicker.CSS.COLOR + '20'};
    color: ${EnumDatepicker.CSS.BLUECOLOR};
    font-weight: 400;

    &:focus {
        outline: none;
        border: 1px solid ${EnumDatepicker.CSS.COLOR};
    }

    &:disabled {
        background: ${EnumDatepicker.CSS.GREY};
    }

    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin: 0;
    }

    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin: 0;
    }
  `;
/**
 * @description : modification des props
 * @const
 * @name  DaySpan
 */
export const DaySpan = styled.span<DaySpanProps>`
    width: 100%;
    padding: 0;
    margin: 0;
    text-align: center;
    cursor: pointer;
    font-size: 12px;
    border: 1px solid transparent;
    &:hover {
      color: ${EnumDatepicker.CSS.TUNNELGREEN}!important;
    }
    color: ${
    (props: DaySpanProps) => props.start || props.end ?
        EnumDatepicker.CSS.WHITE :
        props.muted ? EnumDatepicker.CSS.GREY : EnumDatepicker.CSS.DARKGREY};
    background-color: ${
    props => props.start || props.end ?
        EnumDatepicker.CSS.COLOR :
        props.between ? EnumDatepicker.CSS.COLOR + '20' :
                        props.active ? EnumDatepicker.CSS.COLOR + '40' :
                                       EnumDatepicker.CSS.WHITE};
    font-weight: ${props => props.active ? '700' : props.muted ? '300' : '400'};
  `;
/**
 * @description : modification des props
 * @const
 * @name  DayLabel
 */
export const DayLabel = styled.div<SmallProps>`
    text-transform: uppercase;
    font-weight: 400;
    color: #808080;
    font-size: ${(props: SmallProps) => (props.isSmall ? '13px' : '14px')};
    color: darkgrey;
    margin-bottom: ${(props: SmallProps) => (props.isSmall ? '2px' : '2px')};
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    text-align: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    
    

  `;
/**
 * @description : modification des props
 * @const
 * @name  CalendarDays
 */
export const CalendarDays = styled.nav<SmallProps>`
    font-size: 0;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-gap: ${(props: SmallProps) => (props.isSmall ? '7px' : '15px')} 5px;
    width: 275px;
    align-self: center;
    justify-self: center;
  `;
/**
 * @description : modification des props
 * @const
 * @name  CalendarContainer
 */
export const CalendarContainer = styled.div<CalendarContainerProps>`
    width: ${
    (props: CalendarContainerProps) => props.isSmall ? '320px' : '360px'};
    padding: 0;
    margin-bottom: 10px;
    -moz-box-shadow: 5px 2px 30px 0px rgba(230,230,230,.45);
    -ms-box-shadow: 5px 2px 30px 0px rgba(230,230,230,.45);
    -webkit-box-shadow: 5px 2px 30px 0px rgba(230,230,230,.45);
    box-shadow: 5px 2px 30px 0px rgba(230,230,230,.45);
    border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
    overflow: hidden;
    background: ${EnumDatepicker.CSS.WHITE};
    position: absolute;
    z-index: 10000;
    top: 25px;
    transform: translateY(20px);
    opacity: 0;
    visibility: hidden;
    transform-origin: top center;
    transition: transform 0.3s ease, opacity 0.2s ease, visibility 0s ease 0.3s;
    display: flex;
    flex-direction: column;

    ${(props: CalendarContainerProps) => props.isVisible && css`
            transform: translateY(0);
            opacity: 1;
            visibility: visible;
            transition: transform 0.3s ease, opacity 0.2s ease,
                visibility 0s ease;
        `}
  `;
/**
 * @description : modification des props
 * @const
 * @name  DatePickerContainer
 */
export const DatePickerContainer = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    width:100%;
  `;
/**
 * @description : modification des props
 * @const
 * @name  Input
 */
export const Input = styled.input<SmallProps>`
    top: 0;
    left: 0;
    border: none;
    overflow: hidden !important;
    padding: 0;
    height: 45px;
    width:100%;
    padding-left: 20px;
    border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
    transition: box-shadow 0.3s ease;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    box-sizing:border-box;

    &:focus {
        outline: none;
    }

    &:disabled {
        background: ${EnumDatepicker.CSS.GREY};
    }

    &:hover ${CalendarContainer} {
        transform: scaleY(1) scaleX(1);
    }
  
  `;
/**
 * @description : modification des props
 * @const
 * @name  DropDowContainerHeader
 */
export const DropDowContainerHeader = styled.div<DropDowContainerHeaderProps>`
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 360px;
    height: 45px;
    z-index: 100;
    display: flex;
    align-items: center;
    align-content: center;
    background-color: ${EnumDatepicker.CSS.WHITE};
    padding-left: 0px;
    border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
    overflow: hidden;
    border: 1px solid ${EnumDatepicker.CSS.BORDERCOLOR};
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;

    ::before {
        content: '';
        position: absolute;
        height: 50px;
        width: 50px;
        right: 0px;
        top: 0px;
        background-color: ${EnumDatepicker.CSS.COLOR + '20'};
        border-left: 1px solid ${EnumDatepicker.CSS.BORDERCOLOR};
        border-radius: 0 ${EnumDatepicker.CSS.BORDER_RADIUS} ${
    EnumDatepicker.CSS.BORDER_RADIUS} 0;
        cursor: pointer;
    }

    ${(props: DropDowContainerHeaderProps) => props.error && css`
            border: 1px solid #ed5b56;
        `}
  `;

/**
 * @description : modification des props
 * @const
 * @name  CalenderNav
 */
export const CalenderNav = styled.nav<SmallProps>`
      margin: 0;
      padding: 0;
      background-color: ${EnumDatepicker.CSS.WHITE};
      height: 50px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
  `;
/**
 * @description : modification des props
 * @const
 * @name  CalendarNavLink
 */
export const CalendarNavLink = styled.a<CalendarNavLinkProps>`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: ${
    (props: CalendarNavLinkProps) =>
        props.isRight ? 'auto' : props.isSmall ? '50px' : '70px'};
    right: ${
    (props: CalendarNavLinkProps) =>
        props.isRight ? (props.isSmall ? '50px' : '70px') : 'auto'};
    width: 30px;
    height: 50px;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    text-align: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    opacity: 0.8;

    &:hover {
        opacity: 1;
    }
  `;
/**
 * @description : modification des props
 * @const
 * @name  CalendarNavLinkYear
 */
export const CalendarNavLinkYear = styled.a<CalendarNavLinkProps>`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: ${
    (props: CalendarNavLinkProps) =>
        props.isRight ? 'auto' : props.isSmall ? '20px' : '40px'};
    right: ${
    (props: CalendarNavLinkProps) =>
        props.isRight ? (props.isSmall ? '20px' : '40px') : 'auto'};
    width: 30px;
    height: 50px;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    opacity: 0.8;

    &:hover {
        opacity: 1;
    }
  `;
/**
 * @description : modification des props
 * @const
 * @name  CalendarNavHeader
 */
export const CalendarNavHeader = styled.h1`
    margin: 0;
    text-align: center;
    cursor: pointer;
    font-weight: 500;
    font-size: 1.4em;
    color: ${EnumDatepicker.CSS.BLACK};
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  `;
/**
 * @description : modification des props
 * @const
 * @name  Icon
 */
export const Icon = styled.div`
    position: absolute;
    right: 15px;
    width: 20px;
    transition: transform 0.33s ease;
    cursor: pointer;
  `;

/**
 * @description : modification des props
 * @const
 * @name  IconContainer
 */
export const IconContainer = styled.div`
    width: 12px;
    height: 12px;
    object-fit: contain;
    transition: transform 0.33s ease;
    cursor: pointer;
  `;
/**
 * @description : modification des props
 * @const
 * @name  RadioButton
 */
export const RadioButton = styled.div<RadioButtonProps>`
    width: ${(props: RadioButtonProps) => (props.isSmall ? '28px' : '35px')};
    height: ${(props: RadioButtonProps) => (props.isSmall ? '28px' : '35px')};
    font-size: ${(props: RadioButtonProps) => (props.isSmall ? '13px' : '1em')};
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    color: ${EnumDatepicker.CSS.DARKGREY};
    font-weight: 400;
    border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
    background-color: ${EnumDatepicker.CSS.COLOR + '20'};
    margin-left: 5px;
    margin-right: 5px;
    border: 1px solid transparent;

    ${(props: RadioButtonProps) => props.active && css`
            border: 1px solid ${EnumDatepicker.CSS.COLOR};
        `};
  `;
/**
 * @description : modification des props
 * @const
 * @name  Sep
 */
export const Sep = styled.div`
    width: ${(props: SepProps) => props.width};
    height: ${props => props.height};
  `;
// ====================================================================================================
{ /** INTERFACES */
}
// ====================================================================================================
/**
 * @interface DaySpanProps
 * @description :
 * Cette interface définit le model du props
 */
interface DaySpanProps {
  current?: boolean;
  active?: boolean;
  muted?: boolean;
  start?: boolean;
  end?: boolean;
  between?: boolean;
  isSmall?: boolean;
}
/**
 * @interface SmallProps
 * @description :
 * Cette interface définit le model du props
 */
interface SmallProps {
  isSmall?: boolean, error?: boolean
}
/**
 * @interface LabelProps
 * @description :
 * Cette interface définit le model du props
 */
interface LabelProps {
  width?: string;
  isSmall?: boolean;
}
/**
 * @interface CalendarContainerProps
 * @description :
 * Cette interface définit le model du props
 */
interface CalendarContainerProps {
  isVisible?: boolean;
  isSmall?: boolean;
}
/**
 * @interface CalendarNavLinkProps
 * @description :
 * Cette interface définit le model du props
 */
interface CalendarNavLinkProps {
  isRight?: boolean, isSmall?: boolean,
}
/**
 * @interface DropDowContainerHeaderProps
 * @description :
 * Cette interface définit le model du props
 */
interface DropDowContainerHeaderProps {
  error?: boolean,
}
/**
 * @interface RadioButtonProps
 * @description :
 * Cette interface définit le model du props
 */
interface RadioButtonProps {
  active?: boolean, isSmall?: boolean,
}

/**
 * @interface SepProps
 * @description :
 * Cette interface définit le model du props
 */
interface SepProps {
  width?: string, height?: string, isSmall?: boolean,
}



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@styled/datepicker/index.ts